export const StockStatus = {
    'DP': ["warning", "En deposito"],
    'RP': ["secondary", "Con repositor"],
    'EM': ["primary", "En maquina"],
    'VE': ["success", "Vendido"],
    'DA': ["danger", "Dañado"],
    'PE': ["warning", "Pendiente"],
    'NA': ["success", "Sin asignar"],
    'RS': ["warning", "Reservado"],
};

export const DoorsStatus = {
    'AB': ["warning", "Abierto"],
    'CE': ["primary", "Cerrado"],
    'ER': ["danger", "En deposito"],
};